import { Component, Input, OnInit } from "@angular/core";
import { AccountService } from "../../models/account.service";

@Component({
  selector: "ab-account-apm-cap-reached",
  templateUrl: "./account-apm-cap-reached.component.html",
})
export class AccountApmCapReachedComponent implements OnInit {
  @Input() public user: any;

  public show: boolean;

  constructor(private accountService: AccountService) {}

  public ngOnInit() {
    this.show = false;

    this.accountService.properties().subscribe((props: any) => {
      this.show = props.alerts.apm_cap_alert === true;
    });
  }
}
